/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Button, Tooltip } from 'antd';
import DOMPurify from 'dompurify';
import React, { useState } from 'react';
import { clickCount } from 'src/components/BookSearch/ApiService';
import BookDetailModal from 'src/components/BookSearch/BookDetailModal';

function BookInfo({
  className,
  book: { NumberOfFiles, NumberOfCopies, ClickCount },
}) {
  return (
    <div className={className}>
      <Tooltip title={`Có ${NumberOfFiles} file`} className="pe-3">
       
        <i className="fa-regular fa-floppy-disk pe-2" aria-hidden="true" />
        {NumberOfFiles}
      </Tooltip>
      <Tooltip title={`Có ${NumberOfCopies} bản giấy`} className="pe-3">
        <i className="fa fa-book pe-2" aria-hidden="true" />
        {NumberOfCopies}
      </Tooltip>
      {ClickCount ? (
        <Tooltip title={`Có ${ClickCount} lượt xem`} className="pe-3">
          <span>
            <i className="fa fa-eye pe-2" aria-hidden="true" />
            {ClickCount}
          </span>
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
}

function SnpBookItem({ className, book }) {
  const { Title1, CoverUrl, Author } = book;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const viewDetail = () => {
    clickCount(book.RecordID);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={`book-item border rounded-3 ${className}`}>
      <div className="book-item__img">
        <a href="/">
          <img alt="bookImg" className="img-fluid" src={CoverUrl} />
        </a>
      </div>
      <div className="book-item__content">
        <h6 className="mb-2">
          <a
            href="javascript:void(0)"
            className="book-item__title"
            title={Title1}
            onClick={viewDetail}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(Title1),
            }}
          />
        </h6>
        <div className="text-black-50 mb-2 fs-sm">{Author.join(', ')}</div>
        <BookInfo className="text-danger d-flex mb-2 fs-sm" book={book} />
        <div className="mt-auto">
          <Button
            className="btn btn__detail w-100 rounded-pill fs-sm"
            onClick={viewDetail}
          >
            Chi tiết
          </Button>
        </div>
      </div>
      {isModalOpen && (
        <BookDetailModal
          id={book.RecordID}
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          handleOk={handleOk}
        />
      )}
    </div>
  );
}

export default SnpBookItem;
